import { TestConfigStepType } from '../test-config-steps-provider.interfaces';

const RELATED_STEPS: { [x in TestConfigStepType]: TestConfigStepType[] } = {
  [TestConfigStepType.SET_OPPOSITION]: [TestConfigStepType.SET_EXAM_TYPE_OR_CHALLENGE],
  [TestConfigStepType.SET_EXAM_TYPE_OR_CHALLENGE]: [
    TestConfigStepType.SET_EXAM_TYPE,
    TestConfigStepType.CREATE_CHALLENGE,
  ],
  [TestConfigStepType.SET_EXAM_TYPE]: [TestConfigStepType.SET_EXAM_TEMPLATE, TestConfigStepType.SET_CONTENTS],
  [TestConfigStepType.SET_EXAM_TEMPLATE]: [],
  [TestConfigStepType.SET_NUM_QUESTIONS]: [],
  [TestConfigStepType.SET_CONTENTS]: [TestConfigStepType.SET_ORGANIZATION],
  [TestConfigStepType.SET_ORGANIZATION]: [],
  [TestConfigStepType.CREATE_CHALLENGE]: [],
  [TestConfigStepType.FINISH]: [],
};

export const getRelatedSteps = (stepType: TestConfigStepType) => {
  const baseRelatedSteps = RELATED_STEPS[stepType];
  const relatedSteps = baseRelatedSteps;

  baseRelatedSteps.forEach(relatedStepType => {
    relatedSteps.push(...getRelatedSteps(relatedStepType));
  });
  return [...new Set(relatedSteps)];
};
